import "./HomePage.scss";
// REACT; REDUX; ROUTER
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

// COMPONENTS & FUNCTIONS
import TutorialTool from "../components/tools/TutorialTool";
import CalculatorUnit from "../components/units/CalculatorUnit";

// DATA
import { dummyCalculator, tutorialSteps } from "../data/tutorialCalcData";
import * as calculators from "../engineering/calculators";
import * as catalogues from "../engineering/catalogues";

// SVG & IMAGES
import calcImg from "../img/header-calculator.svg";

// INTERFACES
import { CalculatorUnitProps } from "../interface/propTypesInterface";

// NPM INSTALLS
import * as FaIcons from "react-icons/fa";
import { Calculator } from "../interface/functionalityInterface";
import { DataType } from "../interface/dataTypeInterface";

/*
HOME PAGE COMPONENT INFORMATION
  This is the landing page when starting the app for the first time.
  In here are two link button to Calculator- and Catalogue Page.
*/

const dummyCalc = dummyCalculator as CalculatorUnitProps;

export default function HomePage() {
  // ::::: CONSTANTS :::::

  // ::::: USE HOOKS :::::
  const [showTutorial, setShowTutorial] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    if ("ontouchstart" in window) {
      setIsTouchDevice(true);
    }
  }, []);

  // ::::: HANDLER FUNCTIONS :::::
  const handleCloseTutorial = (closeTutorial: boolean) => {
    if (closeTutorial) setShowTutorial(false);
  };

  const getCalcCount = (): number => {
    const calcs = Object.values(calculators) as Calculator[];
    return calcs.reduce(
      (count, calc) => (count = count + calc.inputs.length),
      0
    );
  };

  const getCatalogueCount = (): number => {
    const cats = Object.values(catalogues) as DataType[][];
    return cats.reduce((count, cat) => (count = count + cat.length), 0);
  };
  // ::::: JSX ::::::
  return (
    <div className="home-page">
      <header>
        <figure className="home-page__logo">
          <img src={calcImg} alt="calc" />
        </figure>
        <h1>Search. Solve. Store.</h1>
        <p>smart and easily available tools to enhance your workflow</p>
        {!isTouchDevice && (
          <button
            onClick={() => setShowTutorial(true)}
            className="rectangular-button translateY"
          >
            How to use the calculator
          </button>
        )}

        {showTutorial && !isTouchDevice && (
          <TutorialTool
            reactComponent={<CalculatorUnit {...dummyCalc} />}
            tutorialSteps={tutorialSteps}
            closeTutorial={handleCloseTutorial}
          />
        )}
        {/* TUTORIAL BUTTON TO COME*/}
      </header>

      <section className="home-page__offer">
        <h2>Let's get started!</h2>
        <h4>Click on either the calculator or the catalogue</h4>

        <div>
          <article style={{ display: "flex", alignItems: "center" }}>
            <NavLink to="/calculator" className={"hover-cursor"}>
              <FaIcons.FaCalculator />
            </NavLink>
            <h3>{getCalcCount()} Calculators*</h3>
            <q>including calculator modes</q>
          </article>
          <article style={{ display: "flex", alignItems: "center" }}>
            <NavLink to="/catalogue" className={"hover-cursor"}>
              <FaIcons.FaBook />
            </NavLink>
            <h3>{getCatalogueCount()} Catalogues*</h3>
            <q>including sub categories</q>
          </article>
        </div>
      </section>

      <section className="home-page__intro">
        <h2>Level up your workflow!</h2>
        <div>
          <article className="inverse-color">
            <FaIcons.FaSearch />
            <h3>search</h3>
            <p>
              Data can be found categorized in Catalogue, where you can easily
              search and find the parameters you are looking for
            </p>
          </article>
          <article className="inverse-color">
            <FaIcons.FaEquals />
            <h3>Solve</h3>
            <p>
              Make easy quick calculations with pre-defined equations, such as
              volume, capacitance and presure drop
            </p>
          </article>
          <article className="inverse-color">
            <FaIcons.FaSimplybuilt />
            <h3>Store</h3>
            <p>
              Everything is offline. Your calculations are saved locally and can
              be exported/imported as JSON files
            </p>
          </article>
          <article className="inverse-color">
            <FaIcons.FaTools />
            <h3>Engineering focus</h3>
            <p>
              Practical calculators and reference data bring common engineering
              tasks together in one clear, accessible workspace
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}
